export default __webpack_public_path__ + "static/media/bg-fifa-1.011fac67.png";